import React from "react";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";

const statusColors = {
  "Pending": { bgcolor: "warning.main", color: "white" },
  "Waiting For Offer": { bgcolor: "info.main", color: "white" },
  "Offer Accepted": { bgcolor: "success.main", color: "white" },
  "Pickup Progress": { bgcolor: "secondary.main", color: "white" },
  "DropOff Progress": { bgcolor: "primary.main", color: "white" },
  "Completed": { bgcolor: "#4CAF50", color: "white" },
  "Cancelled": { bgcolor: "error.main", color: "white" },
  "Scheduled": { bgcolor: "teal.500", color: "white" }
};

const OrderStatusBadge = ({ status }) => {
  const colorStyle = statusColors[status] || { bgcolor: "grey.300", color: "black" };

  return (
    <Box
      sx={{
        px: 1.5,
        py: 0.5,
        borderRadius: "12px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        ...colorStyle,
      }}
    >
      <Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: "bold" }} style={{ color: colorStyle.color }}>
        {status}
      </Typography>
    </Box>
  );
};

OrderStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default OrderStatusBadge;